import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import ids from 'Components/Worksheets/QestIds';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { HandShearVaneTabsSection, MoistureConditionValueTabsSection, PreparationSection } from './Sections';

let BsMoistureConditionValueWorksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const showHsv = useSelector(
    pipe(createWorksheetSelector!('Preparation.HandShearVaneResultRequired'), valueOrDefault(false))
  );

  return (
    <>
      <PageSection heading="Preparation">
        <PreparationSection />
      </PageSection>
      <PageSection heading="Moisture Condition Value">
        <MoistureConditionValueTabsSection />
      </PageSection>
      {showHsv && (
        <PageSection heading="Hand Shear Vane">
          <HandShearVaneTabsSection />
        </PageSection>
      )}
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

BsMoistureConditionValueWorksheet.qestIds = [ids.moistureConditionValue.BS_1377_2_Clause_13_5.rev2022];
BsMoistureConditionValueWorksheet = withInjectedProps(BsMoistureConditionValueWorksheet);

export { BsMoistureConditionValueWorksheet };
export default BsMoistureConditionValueWorksheet;
